import {Screens} from '../../../../routing';

export const SCREENS_WITH_REISSUE_INFO = new Set<string>([
  Screens.Profile,
  Screens.DesktopProfileMe,
  Screens.DesktopProfileSettings,
  Screens.ProfileConfirmation,
  Screens.ProfileApplications,
  Screens.ProfileSafety,
]);

export const SCREENS_WITH_REISSUE_INFO_MOBILE = new Set<string>([Screens.ProfileSafety]);

export const SCREENS_WITHOUT_CARD_BLOCKED_BANNER = new Set<string>([
  Screens.EsiaRegistrationCard,
  Screens.EsiaRegistrationCardMap,
  Screens.EsiaRegistrationCardUserSelecting,
  Screens.EsiaLoginAfterLogged,
]);

export const getFocusedRouteName = (state: any): string | undefined => {
  if (!state) {
    return undefined;
  }
  const route = state.routes[state.index];
  if (route?.state) {
    return getFocusedRouteName(route.state);
  }
  return route?.name;
};
